'use client';

import { useState, useEffect } from 'react';

const STRAPI_URL = process.env.NEXT_PUBLIC_STRAPI_URL || 'http://localhost:1337';

export default function Footer() {
  const [logo, setLogo] = useState<string | null>(null);

  useEffect(() => {
    async function fetchLogo() {
      try {
        const response = await fetch(`${STRAPI_URL}/api/page-accueil?populate=*`, {
          cache: 'no-store',
        });
        const data = await response.json();
        const logoUrl = data?.data?.logo?.url;
        if (logoUrl) setLogo(`${STRAPI_URL}${logoUrl}`);
      } catch (error) {
        console.error('Erreur chargement logo:', error);
      }
    }
    fetchLogo();
  }, []);

  return (
    <footer className="bg-[#005570] text-white relative overflow-hidden">
      {/* Motif court discret */}
      <div className="absolute inset-0 court-pattern opacity-10" />

      {/* Bande signature 5 couleurs */}
      <div className="flex h-1">
        <div className="flex-1 bg-[#006C8F]" />
        <div className="flex-1 bg-[#FFC72C]" />
        <div className="flex-1 bg-[#006C8F]" />
        <div className="flex-1 bg-[#FFC72C]" />
        <div className="flex-1 bg-[#006C8F]" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Branding */}
          <div className="flex flex-col items-start max-w-md">
            <div className="flex items-center gap-3 mb-4">
              {logo ? (
                <div className="w-11 h-11 bg-white rounded-full flex items-center justify-center p-1.5 shadow flex-shrink-0">
                  {/* eslint-disable-next-line @next/next/no-img-element -- images Strapi (hôte variable selon l’environnement) dans des conteneurs dimensionnés en CSS : le passage à next/image demande une vérification visuelle et l’ajout de l’hôte aux remotePatterns. */}
                  <img src={logo} alt="SCH Logo" className="w-full h-full object-contain" />
                </div>
              ) : (
                <div className="w-11 h-11 bg-[#FFC72C] rounded-full flex items-center justify-center font-bold text-[#006C8F] text-xs shadow flex-shrink-0">
                  SCH
                </div>
              )}
              <div>
                <p
                  className="font-bold text-white leading-none"
                  style={{ fontFamily: 'var(--font-playfair), serif' }}
                >
                  Sporting Club Houlgate
                </p>
                <p className="text-white/45 text-[10px] tracking-widest uppercase mt-0.5">
                  Depuis 1906
                </p>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed">
              Un club centenaire au cœur de la Côte Fleurie, alliant tradition sportive et
              convivialité.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8">
            {/* Contact */}
            <div className="max-w-md lg:justify-self-start">
              <p className="text-white/35 text-xs uppercase tracking-widest mb-4 font-medium">
                Contact
              </p>
              <ul className="space-y-3">
                <li>
                  <a
                    href="mailto:sportinghoulgate@gmail.com"
                    className="flex items-center gap-2.5 text-white/65 hover:text-[#FFC72C] transition-colors text-sm"
                  >
                    <svg
                      className="w-4 h-4 text-[#FFC72C] flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                    sportinghoulgate@gmail.com
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+33231248765"
                    className="flex items-center gap-2.5 text-white/65 hover:text-[#FFC72C] transition-colors text-sm"
                  >
                    <svg
                      className="w-4 h-4 text-[#FFC72C] flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                    02 31 24 87 65
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-12 pt-6 text-center">
          <p className="text-white/25 text-xs">
            © 2026 Sporting Club Houlgate — Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
}
